import { createFileRoute } from '@tanstack/react-router'
import { Changelog } from '@/features/changelog'

export const Route = createFileRoute('/_authenticated/changelog/')({
  component: Changelog,
})
